/* import __COLOCATED_TEMPLATE__ from './header.hbs'; */
import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'thead',
  classNames: ['card__attributes-table__header']
});